export default __webpack_public_path__ + "static/media/report-analytics-ar.339edb1b.png";